import InfoIcon from '@/assets/svg/information.svg';
import { FiCheck, FiEdit2, FiLock, FiMinus, FiPlus, FiSave, FiSlash, FiTrash, PiCaretDownBold, PiCaretRightBold } from '@/components/react-icons/main';

export const DeleteIcon = FiTrash;
export const AddIcon = FiPlus;
export const MinusIcon = FiMinus;
export const ExpandIcon = PiCaretRightBold;
export const CollapseIcon = PiCaretDownBold;
export const InformationIcon = InfoIcon;
export const SaveIcon = FiSave;
export const EditIcon = FiEdit2;
export const LockIcon = FiLock;
export const CancelIcon = FiSlash;
export const ConfirmIcon = FiCheck;
